/**
 * Exchange rate announcement — legacy ys142857 parity (wordings only).
 */
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThemedPageHeader } from '../components/ui/ThemedPageHeader';
import { THEMED_SURFACE_COLORS as C } from '../components/ui/ThemedSurface';

export function ExchangeCalc() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const lines = t('exchangeCalc.lines', { returnObjects: true }) as string[];

  return (
    <div className="relative min-h-full" style={{ background: C.pageBg }}>
      <div className="relative mx-auto min-h-full w-full max-w-[430px]">
        <ThemedPageHeader title={t('exchangeCalc.title')} onBack={() => navigate(-1)} theme={C} />
        <div
          className="overflow-y-auto px-5 pt-[70px] text-sm leading-[1.65]"
          style={{ height: 'calc(100% - 70px)', paddingBottom: '32px', color: C.text }}
        >
          {Array.isArray(lines) &&
            lines.map((line, index) => (
              <p key={index} className={index > 0 ? 'mt-4' : undefined}>
                {line}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
}
